// FilterFunction.js
import { useMemo } from 'react';

const useFilteredData = (mappedData = [], searchText) => {
  // פונקציית החיפוש
  const searchTextRegex = useMemo(() => {
    let pattern = searchText.replace(/[-\/\\^$+?.()|[\]{}]/g, '\\$&');
    pattern = pattern.replace(/\*/g, '.*');
    return new RegExp(pattern, 'i');
  }, [searchText]);

  // סינון השורות על פי הביטוי הרגולרי
  const filteredRows = useMemo(() => {
    return mappedData?.filter((row) => {
      return Object.keys(row).some((key) => {
        const value = row[key];
        if (typeof value === 'string') {
          return searchTextRegex.test(value);
        }
        return false;
      });
    });
  }, [mappedData, searchTextRegex]);

  return filteredRows;
};

export default useFilteredData;
